function addMainProductToCart() {
  const button = event.target;
  const variantId = button.getAttribute('data-variant-id');

  if (!variantId) {
    console.error('No variant ID found on button');
    return;
  }

  const originalText = button.textContent;
  button.textContent = 'Adicionando...';
  button.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      button.textContent = 'Adicionado!';

      // Try to refresh cart without page reload
      refreshCartDisplay();

      // Reset button after 2 seconds
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
      button.textContent = 'Erro! Tente novamente';

      // Reset button after 2 seconds
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    });
}

function refreshCartDisplay() {
  if (typeof window.updateCartDrawer === 'function') {
    window.updateCartDrawer();
  } else if (typeof window.refreshCart === 'function') {
    window.refreshCart();
  } else if (window.theme && window.theme.ajaxCart && typeof window.theme.ajaxCart.load === 'function') {
    window.theme.ajaxCart.load();
  } else if (typeof Shopify !== 'undefined' && Shopify.updateCartFromForm) {
    Shopify.updateCartFromForm();
  } else {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count');
        cartCountElements.forEach((element) => {
          if (element) {
            element.textContent = cart.item_count;
          }
        });

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

        if (typeof window.dispatchEvent === 'function') {
          window.dispatchEvent(new CustomEvent('cartUpdated', { detail: cart }));
        }
      })
      .catch((error) => {});
  }
}
